var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "span",
            {
              staticClass: "tabItem",
              class: { active: _vm.active === 0 },
              on: {
                click: function ($event) {
                  return _vm.handleTabClick(0)
                },
              },
            },
            [_vm._v(" 海运 ")]
          ),
          _c(
            "span",
            {
              staticClass: "tabItem",
              class: { active: _vm.active === 1 },
              on: {
                click: function ($event) {
                  return _vm.handleTabClick(1)
                },
              },
            },
            [_vm._v(" 空运 ")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "optheader" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: "export",
                    expression: "'export'",
                  },
                ],
                staticClass: "btn flex_c_c",
                staticStyle: { "margin-right": "12px" },
                on: { click: _vm.handleExport },
              },
              [_c("i", { staticClass: "el-icon-download" }), _vm._v(" 导出 ")]
            ),
            _c(
              "BaseFilter",
              {
                attrs: { "is-active": _vm.isActive, width: 466 },
                on: {
                  sendFilter: _vm.handleSearchOk,
                  reset: _vm.handleSearchReset,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "searchForm",
                        attrs: { model: _vm.searchData, "label-width": "70px" },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "310px" },
                                attrs: {
                                  filterable: "",
                                  multiple: "",
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.searchData.companyId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchData, "companyId", $$v)
                                  },
                                  expression: "searchData.companyId",
                                },
                              },
                              _vm._l(_vm.companyOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "搜索" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: { placeholder: "提单号" },
                              model: {
                                value: _vm.searchData.search,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchData, "search", $$v)
                                },
                                expression: "searchData.search",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _c(
            "el-tabs",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "el-tabs",
              attrs: { type: "border-card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.TaxManagementStatus,
                callback: function ($$v) {
                  _vm.TaxManagementStatus = $$v
                },
                expression: "TaxManagementStatus",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "所有(" + _vm.form.all + ")", name: "All" },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "待上传(" + _vm.form.one + ")",
                  name: "ToBeUploaded",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "待确认(" + _vm.form.two + "）",
                  name: "ToBeConfirmed",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "已确认(" + _vm.form.four + "）",
                  name: "Confirmed",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "已拒绝(" + _vm.form.three + "）",
                  name: "Rejected",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "作废(" + _vm.form.five + "）",
                  name: "Cancel",
                },
              }),
              _c(
                "div",
                { staticClass: "table" },
                [
                  _c("BaseTable", {
                    key: _vm.TaxManagementStatus,
                    attrs: {
                      height: _vm.height,
                      "table-data": {
                        ..._vm.list,
                        fileds: _vm.fileds,
                      },
                      "page-number": _vm.pager.PageIndex,
                      "page-size": _vm.pager.PageSize,
                    },
                    on: {
                      handlePageChange: _vm.handlePageChange,
                      dblclick: _vm.handleRowDoubleClick,
                      "selection-change": _vm.handleSelectionChange,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "opt",
                        fn: function (row) {
                          return [
                            _c(
                              "el-popover",
                              {
                                ref: `popover${row.scope.id}`,
                                attrs: {
                                  placement: "bottom-start",
                                  "popper-class": "pop-table-opt",
                                  width: "114",
                                  trigger: "click",
                                },
                              },
                              [
                                _c("div", { staticClass: "table-opt" }, [
                                  row.scope.status === 0
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "upload",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("上传税金")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "updateupload",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("更新税金")]
                                          ),
                                        ],
                                        1
                                      ),
                                ]),
                                _c("img", {
                                  attrs: {
                                    slot: "reference",
                                    src: require("@/assets/images/table/opt.png"),
                                  },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "fileNumber",
                        fn: function (row) {
                          return [
                            _c(
                              "i",
                              {
                                staticClass: "el-icon-folder-opened",
                                staticStyle: { color: "black" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewFile(row.scope)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(row.scope.fileNumber))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            visible: _vm.dialogVisible,
            top: "7vh",
            title: `上传7501 - ${_vm.titleMblNo} - (${_vm.titleQty})`,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleDialogClose,
            width: "32%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "uploadForm",
              staticStyle: { "margin-right": "20px", "margin-bottom": "-20px" },
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "提单号", prop: "mblNo" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.mblNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "mblNo", $$v)
                              },
                              expression: "form.mblNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "EntryNo", prop: "entryNo" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.entryNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "entryNo", $$v)
                              },
                              expression: "form.entryNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "提单件数", prop: "qty" } },
                        [
                          _c("el-input", {
                            attrs: { autocomplete: "off", type: "number" },
                            model: {
                              value: _vm.form.qty,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "qty", _vm._n($$v))
                              },
                              expression: "form.qty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "税金", prop: "amount" } },
                        [
                          _c("el-input", {
                            attrs: { autocomplete: "off", type: "number" },
                            model: {
                              value: _vm.form.amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "amount", _vm._n($$v))
                              },
                              expression: "form.amount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "It.NO", prop: "itNumber" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.itNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "itNumber", $$v)
                              },
                              expression: "form.itNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 4 },
                              placeholder: "请输入内容",
                            },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "文件", prop: "file" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      staticStyle: {
                        display: "contents",
                        "margin-right": "auto",
                      },
                      attrs: {
                        drag: "",
                        limit: 1,
                        action: "#",
                        "show-file-list": true,
                        "http-request": _vm.handleHttpRequest,
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("拖拽或"),
                        _c("em", [_vm._v("点击上传")]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleDialogClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitFinalForm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ClearenceFileDialog", {
        attrs: { rowData: _vm.rowData, dialogVisible: _vm.dialogVisible1 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("DetailDrawer", {
        attrs: {
          drawer: _vm.drawer1,
          billType: _vm.active,
          rowData: _vm.rowData,
        },
        on: {
          close: function ($event) {
            _vm.drawer1 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }